import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {Price} from '../types';
import {StatusBadge} from "../profile/StatusBadge.tsx";

export const getColumns = (onRecordClick?: (record: Price) => void) => [
    {
        title: I18n.get('Price'),
        width: '1fr',
        render: (item: Price) => onRecordClick ? (
            <span
                style={{color: 'var(--mantine-color-blue-6)', cursor: 'pointer'}}
                onClick={() => onRecordClick(item)}
            >
                {item.id}
            </span>
        ) : item.id,
    },
    {
        title: I18n.get('Product'),
        width: '1fr',
        render: (item: Price) => item.product,
    },
    {
        title: I18n.get('Unit Amount'),
        width: '1fr',
        render: (item: Price) => item.unitAmount,
    },
    {
        title: I18n.get('Active'),
        width: '1fr',
        render: (item: Price) => <StatusBadge active={item.active}/>,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: Price) => formatTimestamp(item.created as string),
    },
];

// Keep backward-compatible export for any remaining consumers
export const columns = getColumns();
